import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import LiveStats from "@/components/LiveStats";
import MemeReel from "@/components/MemeReel";
import Lore from "@/components/Lore";
import HowToBuy from "@/components/HowToBuy";
import Footer from "@/components/Footer";
import { useStats } from "@/hooks/useStats";

export default function Landing() {
  const { stats, loading, error } = useStats();

  return (
    <div className="grain relative overflow-x-hidden">
      <Nav />
      <main>
        <Hero stats={stats} />
        <Ticker stats={stats} />
        <LiveStats stats={stats} loading={loading} error={error} />
        <MemeReel />
        <Lore />
        <HowToBuy />
        <Ticker stats={stats} variant="lime" />
        <Footer />
      </main>
    </div>
  );
}
